'use client';

import { createContext, useContext } from 'react';
import { Theme, isValidTheme } from '../themes';
import { warn } from '../tracking/logging';

interface ThemeContextValue {
  theme: Theme;
}

const ThemeContext = createContext<ThemeContextValue>({ theme: 'classic' });

export function ThemeProvider({ 
  theme, 
  children 
}: { 
  theme: Theme; 
  children: React.ReactNode;
}) {
  // Validate theme at runtime
  if (!isValidTheme(theme)) {
    warn('theme', 'INVALID_THEME_FALLBACK', { theme });
    theme = 'classic';
  }
  
  return (
    <ThemeContext.Provider value={{ theme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
